import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11_@vue+compil_ae6d9d3f41d8155d2afb70dc2566bba7/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}